import React, { useState, useEffect, useRef } from 'react';
import './update-banner.css';

export default function UpdateBanner() {
  const [visible, setVisible] = useState(false);
  const registrationRef = useRef(null);

  useEffect(() => {
    const handleUpdate = (e) => {
      registrationRef.current = e.detail;
      setVisible(true);
    };

    window.addEventListener('swUpdate', handleUpdate);
    return () => window.removeEventListener('swUpdate', handleUpdate);
  }, []);

  const handleUpdateClick = () => {
    const registration = registrationRef.current;
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  if (!visible) return null;

  return (
    <div className="update-banner">
      <span className="update-banner-text">
        A new version of Lightway is available.
      </span>
      <button className="update-banner-btn" onClick={handleUpdateClick}>
        Update
      </button>
      <button className="update-banner-close" onClick={() => setVisible(false)}>
        ✕
      </button>
    </div>
  );
}
